import { Button, Spinner } from '@monksflow/monks-ui';
import {
  PageHeader,
  PageHeaderActions,
  PageHeaderBackButton,
  PageHeaderBreadcrumb,
  PageHeaderBreadcrumbLink,
  PageHeaderBreadcrumbPage,
  PageHeaderIdentity,
} from '@/shared/ui/layout';
import { ROUTES } from '@/shared/config/routes';
import { useTranslation } from 'react-i18next';

interface TemplateEditorHeaderProps {
  templateName: string;
  canSave: boolean;
  isSaving: boolean;
  onBack: () => void;
  onSave: () => void;
}

export function TemplateEditorHeader({
  templateName,
  canSave,
  isSaving,
  onBack,
  onSave,
}: TemplateEditorHeaderProps) {
  const { t } = useTranslation('admin');

  return (
    <PageHeader>
      <PageHeaderIdentity>
        <PageHeaderBackButton onClick={onBack} />
        <PageHeaderBreadcrumb>
          <PageHeaderBreadcrumbLink href={ROUTES.KNOWLEDGE_HUB_TEMPLATES}>
            {t('templatesConfig.editor.emailTemplates')}
          </PageHeaderBreadcrumbLink>
          <PageHeaderBreadcrumbPage>{templateName}</PageHeaderBreadcrumbPage>
        </PageHeaderBreadcrumb>
      </PageHeaderIdentity>
      <PageHeaderActions>
        <Button variant="default" size="lg" onClick={onSave} disabled={!canSave}>
          {isSaving && <Spinner />}
          {t('templatesConfig.editor.save')}
        </Button>
      </PageHeaderActions>
    </PageHeader>
  );
}
